import {
	MimaButton,
	MimaDropdown,
	MimaText,
	Modal,
} from '../../components';
import { employeeStore } from '../../stores';
import { Formik } from 'formik';
import React from 'react';

const ApproveCommissionPayment = ({
	closeModal,
	validationSchema,
	onSubmit,
	loading,
	goBack,
}) => {
	return (
		<Modal closeModal={closeModal} goBack={goBack}>
			<MimaText variant="subtitle" color="var(--color-primary)" align="center">
				Action UNPAID Commission Payments
			</MimaText>
			<Formik
				initialValues={{
					tag: '',
					action: '',
				}}
				validationSchema={validationSchema()}
				onSubmit={onSubmit}>
				{({
					handleChange,
					handleBlur,
					handleSubmit,
					setFieldValue,
					values,
					errors,
					touched,
				}) => (
					<div>
						<MimaDropdown
							labelTitle="Tags"
							placeholder="Select"
							name="tag"
							value={values.customerGroupName}
							id="tag"
							onChange={data => {
								setFieldValue('tag', data.key);
							}}
							error={errors.tag}
							data={employeeStore.tags}
							touched={touched.tag}
						/>

						<MimaDropdown
							labelTitle="Action"
							placeholder="Select"
							name="action"
							value={values.action}
							id="tag"
							onChange={data => {
								setFieldValue('action', data.key);
							}}
							data={[
								{ key: 'APPROVED', value: 'APPROVED' },
								{ key: 'VOID', value: 'VOID' },
							]}
							error={errors.action}
							touched={touched.action}
						/>
						<MimaButton
							title="Continue"
							loading={loading}
							type="submit"
							onClick={handleSubmit}
						/>
					</div>
				)}
			</Formik>
		</Modal>
	);
};

export default ApproveCommissionPayment;
